import { useAllBrands } from "http-hooks/brand/useBrand";
import DeleteSubBrand from "components/subBrand/DeleteSubBrand";
import { useState } from "react";
import useModalStore from "store/modals";
import InputSearch from "components/ui/InputSearch";
import Select from "components/ui/Select";
import { SelectBrandAndSubbrands } from "components/ui/selectors";
import MasterPage, {
  FilterRow,
  FilterCell,
  ClearFiltersButton,
  AddButton,
  StatusIcon,
  EditAction,
  DeleteAction,
} from "components/ui/MasterPage";

const statusOptions = [
  { value: "", label: "All Status" },
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];

const initialFilter = {
  brandname: "",
  parentid: "",
  ag_status: "",
  level: 2,
  page: 1,
  limit: 10,
};

export default function SubBrandMaster() {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [filter, setFilter] = useState(initialFilter);
  const { openModal } = useModalStore();

  const openSetModal = (id) => openModal("subbrand", id);

  const handleSearch = (searchTerm) => {
    setFilter((prev) => ({ ...prev, brandname: searchTerm, page: 1 }));
  };

  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setFilter((prev) => ({ ...prev, ag_status: selectedOption?.value || "", page: 1 }));
  };

  const handleBrandChange = (selectedOption) => {
    setSelectedBrand(selectedOption);
    setFilter((prev) => ({ ...prev, parentid: selectedOption?.value || "", page: 1 }));
  };

  const clearFilters = () => {
    setSelectedStatus(null);
    setSelectedBrand(null);
    setFilter(initialFilter);
  };

  const {
    isLoading,
    data: { data: allbrands, page: currentPage, totalPages } = [],
  } = useAllBrands(filter);

  const { data: { data: allmainbrands } = [] } = useAllBrands({
    brandname: "",
    parentid: "",
    ag_status: "",
  });

  const columns = [
    { key: "brandname", header: "Name" },
    {
      key: "parentid",
      header: "Brand Name",
      render: (item) =>
        allmainbrands?.find((b) => b.id === item.parentid)?.brandname,
    },
    { key: "level", header: "Level" },
    {
      key: "boolsubbrandshow",
      header: "Sub Brand Show",
      render: (item) => <StatusIcon value={item.boolsubbrandshow} />,
    },
    {
      key: "ag_status",
      header: "Status",
      render: (item) => <StatusIcon value={item.ag_status} />,
    },
    { key: "actions", header: "Actions", isActions: true },
  ];

  return (
    <MasterPage
      title="Sub Brand Master"
      headerActions={
        <AddButton onClick={() => openSetModal()}>Add sub brand</AddButton>
      }
      filters={
        <FilterRow>
          <FilterCell>
            <InputSearch
              onSearch={handleSearch}
              label="Sub Brand Name"
              placeholder="Search Sub Brand Name"
            />
          </FilterCell>
          <FilterCell>
            <SelectBrandAndSubbrands
              value={selectedBrand}
              onChange={handleBrandChange}
              label="Parent Brand"
              placeholder="All Brands"
              filters={{ level: 1, ag_status: 1 }}
            />
          </FilterCell>
          <FilterCell>
            <Select
              options={statusOptions}
              value={selectedStatus}
              onChange={handleStatusChange}
              label="Status"
              placeholder="Select status"
              isClearable={true}
              isSearchable={false}
            />
          </FilterCell>
          <ClearFiltersButton onClick={clearFilters} />
        </FilterRow>
      }
      columns={columns}
      data={allbrands}
      isLoading={isLoading}
      rowKey="id"
      deleteComponent={DeleteSubBrand}
      renderActions={(item, setDeleteItemId) => (
        <>
          <EditAction
            onClick={() => openSetModal(item.id)}
            title="Edit Sub Brand"
          />
          <DeleteAction
            onClick={() => setDeleteItemId(item.id)}
            title="Delete Sub Brand"
          />
        </>
      )}
      pagination={{
        currentPage,
        totalPages,
        onPageChange: (page) => setFilter((prev) => ({ ...prev, page })),
      }}
    />
  );
}
